import { applyMiddleware, createStore } from 'redux'
import thunkMiddleware from 'redux-thunk'
import reducer from './reducer'

/* Redux Thunk middleware allows you to write action creators
 that return a function instead of an action. */
const store = createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(
    thunkMiddleware
  )
)

export default store



// WEBPACK FOOTER //
// ./src/config/store.js